import React from "react";
import { InfoText } from "components/items";
import ContactEmail from "../items/ContactEmail";

const sectionTitle = [
	{
		text: "CONTACT",
		color: "defualt",
		break: false,
	},
	{
		text: "US",
		color: "main",
		break: true,
	},
];

const Contact = (props) => {
	return (
		<section className={`Contact ${props.className}`} id="contact">
			<div className="con">
				<InfoText title={sectionTitle} paragraph={["주문 제작 방식, 마케팅 제휴 문의 등 동구밭에 대해 궁금한 점은 무엇이든 연락 주세요.", "최대한 가까운 시일 내에 답변드리겠습니다. "]} btnText="" />

				<ContactEmail />

				{/* <Form setIsLoading = {setIsLoading} /> */}
			</div>
		</section>
	);
};

export default Contact;
